import classNames from "classnames";
import {ReactNode} from "react";

import {Accordion} from "@/components/accordion/Accordion.tsx";

import styles from "./MarketingFAQs.module.scss";

interface FAQ {
  question: ReactNode | string;
  answer: ReactNode;
}

type MarketingFAQVariant = "default" | "small";

interface MarketingFAQsProps {
  title?: string;
  description?: string;
  items: FAQ[];
  defaultActiveKey?: string;
  variant?: MarketingFAQVariant;
}

export const MarketingFAQs = ({
  title,
  description,
  items,
  defaultActiveKey,
  variant = "default",
}: MarketingFAQsProps) => {
  return (
    <div className={classNames(styles.container, styles[variant])}>
      {title && <h3 className={classNames("marketingTextH3Bold text-center", {"mb-5": !description})}>{title}</h3>}
      {description && <div className="marketingTextBody text-center pulse-color-gray-700 mt-3 mb-5">{description}</div>}
      <Accordion defaultActiveKey={defaultActiveKey} className={styles.faqContainer}>
        {items.map(({question, answer}, index) => (
          <Accordion.Item key={index} eventKey={`${index}`} className={styles.faq}>
            <Accordion.Header className={styles.question}>
              {typeof question === "string" ? (
                <div className="marketingTextS3Bold pulse-color-gray-800">{question}</div>
              ) : (
                question
              )}
            </Accordion.Header>
            <Accordion.Body className={styles.answer}>{answer}</Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};
